import { ingestAPIObject } from "../utils/api";
export class Crop {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
